import React, { useState, useMemo, memo, useRef, useEffect } from "react";
import { NodeResizer } from "reactflow";

const ImageNode = memo(function ImageNode({ data, selected, width: nodeWidth, height: nodeHeight, id }) {
  // 노드의 width/height 속성을 우선 사용, 없으면 data에서 가져옴
  const width = nodeWidth || data?.width || 300;
  const height = nodeHeight || data?.height || 200;
  const { 
    imageUrl = "",
    imageName = "이미지",
    opacity = 1
  } = data || {};

  const [imageError, setImageError] = useState(false);
  
  // 이미지 URL을 메모이제이션하여 불필요한 재렌더링 방지
  const memoizedImageUrl = useMemo(() => imageUrl, [imageUrl]);
  const nodeRef = useRef(null);
  return (
    <>
    <div
      ref={nodeRef} 
      style={{ 
        width: `${width}px`, 
        height: `${height}px`,
        position: "relative",
        overflow: "visible",
        backgroundColor: "transparent",
        willChange: "transform",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden"
      }}
    >
      {/* 리사이저 - 다른 노드와 동일한 스타일 */}
      <NodeResizer
        color="#000000"
        lineColor="#000000"
        lineStyle={{ stroke: "#000000", strokeWidth: 1, zIndex: 1000 }}
        handleStyle={{
          backgroundColor: "#ffffff",
          border: "4px solid #000000",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          boxSizing: "border-box",
          boxSizing: "border-box",
          zIndex: 1001,
        }}
        isVisible={selected}
        minWidth={50}
        minHeight={50}
      />
      
      {/* 이미지 컨테이너 - overflow hidden으로 이미지만 클리핑 */}
      <div style={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        position: "relative",
        zIndex: 1
      }}>
        {/* 이미지 표시 */}
        {memoizedImageUrl && !imageError ? (
          <img 
            key={`${id}-${memoizedImageUrl}`}
            src={memoizedImageUrl}
            alt={imageName}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "fill",
              opacity: opacity,
              pointerEvents: "none",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
              display: "block"
            }}
            onError={() => setImageError(true)}
            draggable={false}
            loading="lazy"
          />
        ) : (
          <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#9ca3af",
            fontSize: "14px",
            backgroundColor: "rgba(0,0,0,0.05)",
            border: "1px dashed #ccc"
          }}>
            {imageError ? "이미지 로드 실패" : "이미지 없음"}
          </div>
        )}
      </div>
    </div>
    
  </>
  );
}, (prevProps, nextProps) => {
  // 커스텀 비교 함수: position, size, imageUrl, selected, selectedBy, showUserLabel이 같으면 re-render 방지
  return (
    prevProps.id === nextProps.id &&
    prevProps.selected === nextProps.selected &&
    prevProps.width === nextProps.width &&
    prevProps.height === nextProps.height &&
    prevProps.data?.imageUrl === nextProps.data?.imageUrl &&
    prevProps.data?.opacity === nextProps.data?.opacity &&
    prevProps.data?.width === nextProps.data?.width &&
    prevProps.data?.height === nextProps.data?.height &&
    prevProps.data?.selectedBy === nextProps.data?.selectedBy &&
    prevProps.data?.showUserLabel === nextProps.data?.showUserLabel
  );
});

export default ImageNode;

